import React, { useState, useCallback, useEffect } from 'react';
import { Layout, Table, Tag } from 'antd';
import useApplicationSession from '../../session/UserSession';
import { getSubscription } from '../../api';
import { Link } from 'react-router-dom';
const { Content } = Layout;

const SubscriptionHistory = () => {
    const [subscriptions, setSubscription] = useState([]);
    const token = useApplicationSession();

    const loadSubscription = useCallback(() => {
        if (token) {
            getSubscription({ token, status: 'closed,rejected' })
                .then((response) => {
                    setSubscription(response);
                })
                .catch((error) => {});
        }
    }, [token]);

    useEffect(() => {
        loadSubscription();
    }, [loadSubscription]);

    return (
        <Content className="subscriptionHistoryContainer">
            <label>Subscription History</label>
            <Table columns={columns} dataSource={subscriptions} />
            <div className="clearfix"></div>
        </Content>
    );
};

export default SubscriptionHistory;

const columns = [
    {
        title: 'Confirmation Number',
        dataIndex: 'confirmation_number',
        key: 'confirmation_number',
        render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    },
    {
        title: 'Vehicle',
        dataIndex: 'vehicle',
        key: 'vehicle',
        render: (vehicle) => (
            <span>
                <p style={{ fontSize: 10, fontWeight: 700 }}>{vehicle.name}</p>
                <p style={{ fontSize: 10 }}>{vehicle.license_plate_number}</p>
            </span>
        ),
    },
    {
        title: 'Period of Hire',
        dataIndex: 'period_of_hire',
        key: 'period_of_hire',
        render: (text) => <p style={{ fontSize: 10 }}>{`${text} Months`}</p>,
    },
    //   {
    //     title: "Monthly Rate",
    //     dataIndex: "monthly_rate",
    //     key: "monthly_rate",
    //     render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    //   },
    {
        title: 'Next Payment',
        dataIndex: 'next_payment',
        key: 'next_payment',
        render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    },
    //   {
    //     title: "TotalAmount",
    //     dataIndex: "total_price",
    //     key: "total_price",
    //     render: (text) => <p style={{ fontSize: 10 }}>{text}</p>,
    //   },
    {
        title: 'Status',
        key: 'status',
        dataIndex: 'status',
        render: (text) => (
            <span>
                <Tag color={getTagColor(text)} style={{ fontSize: 10 }}>
                    {text}
                </Tag>
            </span>
        ),
    },
    {
        title: 'Action',
        key: 'action',
        render: (record) => {
            return (
                <span>
                    <Link
                        // target="_blank"
                        style={{ fontSize: 10, padding: 5 }}
                        to={{
                            pathname: `/subscriptions/history/${record.confirmation_number}`,
                            // search: `?ref=${record.confirmation_number}`,
                            state: record,
                        }}
                    >
                        Detail
                    </Link>
                </span>
            );
        },
    },
];

const getTagColor = (type) => {
    switch (type) {
        case 'pending':
            return 'orange';
        case 'open':
            return 'green';
        case 'rejected':
            return 'red';
        default:
            break;
    }
};
